interface Agent {
    id: number;
    name: string
    /** Friendly name for UI / attendance; `name` (user_name) may stay generic */
    display_name?: string;
    car?: string;
    phone?: string;
    isManager: boolean
    isDriver: boolean
    isCollector: boolean
    isAgent: boolean
    /** Not an agent, collector, or driver */
    isWorker?: boolean
    active: boolean,
    /** 1 = can show dashboard, 0 = hide */
    showDashboard: boolean,
    start_point?:string,
    end_point?:string,
    comment?:string,
    password?:string,
    increase_id?:number,
    nkObject: any;
}
/** 0 agent, 1 driver, 2 collector, 3 worker (none of the role flags). */
export const getType = (a: Agent): number => {
    if (a.isAgent)
        return 0
    else if (a.isDriver)
        return 1
    else if (a.isCollector)
        return 2
    else
        return 3
};

export const agentTypeLabel = (a?: { isAgent?: boolean; isCollector?: boolean; isDriver?: boolean }): string => {
    if (a?.isAgent) return "סוכן";
    if (a?.isCollector) return "מלקט";
    if (a?.isDriver) return "נהג";
    return "עובד";
};

export const USER_TYPE_OPTIONS = [
    { name: "סוכן", type: 0 },
    { name: "נהג", type: 1 },
    { name: "מלקט", type: 2 },
    { name: "עובד", type: 3 },
];
export const deserializeAgent = (a): Agent =>{

    return ({
        id: a.id,
        isCollector: a.is_collector >= 1,
        isDriver: a.is_driver >= 1,
        isAgent: a.is_agent === 1,
        isWorker: !(a.is_agent === 1) && !(a.is_collector >= 1) && !(a.is_driver >= 1),
        isManager: a.manager >= 1,
        /** Only show dashboard when explicitly 1 */
        showDashboard: a.show_dashboard === 1,
        start_point:a.start_point,
        end_point:a.end_point,
        name: a.user_name,
        display_name: a.display_name ?? '',
        car: a.car ?? '',
        phone: a.phone ?? '',
        comment: a.comment,
        password: a.user_password ?? '',
        active: a.active>=1,
        increase_id: a.increase_id,
        nkObject: a
    })
} ;
export default Agent;
